import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { AltitudeRangeState } from "../altitudeRangeReducer";

export const changeUpperLimitPartialReducer: IPartialReducer<AltitudeRangeState> = (state, action) => {
    return {
        ...state,
        upperLimit: action.upperLimit,
    };
};
